import { useContext } from 'react';
import { GlobalContext } from '../context';
import defaultLocale from '../locale';
import publicLocale from '../locale/public';
function useLocale(locale = null) {
  const {
    lang
  } = useContext(GlobalContext);
  return {
    ...(defaultLocale[lang] || {}),
    ...(publicLocale[lang] || {}),
    ...((locale || {})[lang] || {})
  };
}
export default useLocale;